export default class {
    constructor (lodash) {
        this.lodash = lodash;
    }

    // NOTE: api needs re-thinking as it should not return errors in such different formats
    getAnswerErrors (form) {
        if (typeof form.errors.questionAnswers === 'string') {
            return [form.errors.questionAnswers];
        }
        return [];

        // temporarily commented out because not sure if this is needed
        // const lodash = this.lodash;
        // return lodash.uniq(
        //     lodash.map(
        //         lodash.omitBy(form.errors.questionAnswers, lodash.isNil), (error) => {
        //             const defaultLangError = lodash.get(error, `translations.${this.defaultLanguage}.text`);
        //             if (defaultLangError) {
        //                 return defaultLangError;
        //             }
        //             return Object.values(error)[0];
        //         }
        //     )
        // );
    }
}



// WEBPACK FOOTER //
// ./src/app/services/question/form/index.js